import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ButtonStyleTypes } from '../../atoms/buttons/enums.js';
import { setDataAttributes, isRTL } from '../../utilities/dom-helpers/index.js';
import { setLineClamp } from '../../utilities/text-helpers/index.js';
import css_248z from './icons-and-info-block.scss.js';

class IconsAndInfoBlock extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.divider = false;
        this.styleType = ButtonStyleTypes.LIGHT;
        this.headingSlot = null;
        this.textSlot = null;
        this.isIcon = false;
        this.enableSpacing = false;
    }
    setOneThirdLayout() {
        const iconsSlot = this.shadowRoot.querySelector('slot[name="icons"]');
        const updateLayout = () => {
            const windowSize = window.innerWidth;
            const iconsContainer = iconsSlot.assignedElements()[0].children;
            const iconsArray = Array.from(iconsContainer);
            iconsArray.forEach((icon) => {
                const localIcon = icon;
                localIcon.setAttribute('isfourcols', '');
                localIcon.style.maxWidth = windowSize < 768 ? '100%' : '33.3%';
            });
        };
        updateLayout();
        window.addEventListener('resize', updateLayout);
    }
    firstUpdated() {
        setDataAttributes(this, 'heading', null);
        setLineClamp(this, 99, 299);
        this.setOneThirdLayout();
    }
    render() {
        const classes = {
            'icons-and-info-block': true,
            [this.styleType]: this.styleType,
            rtl: this.rtl || isRTL(),
            divider: this.divider,
            'icons-grid-container': true,
            'default-space-between-cards': this.enableSpacing,
        };
        return x `<div class="${o(classes)}"><hr class="separator"><header><slot name="heading"></slot></header><div class="icons-container"><slot name="icons"></slot></div><slot name="cta"></slot></div>`;
    }
}
IconsAndInfoBlock.styles = css_248z;
__decorate([
    n({ type: Boolean })
], IconsAndInfoBlock.prototype, "rtl", void 0);
__decorate([
    n({ type: Boolean })
], IconsAndInfoBlock.prototype, "divider", void 0);
__decorate([
    n({ type: String })
], IconsAndInfoBlock.prototype, "styleType", void 0);
__decorate([
    t()
], IconsAndInfoBlock.prototype, "headingSlot", void 0);
__decorate([
    t()
], IconsAndInfoBlock.prototype, "textSlot", void 0);
__decorate([
    n({ type: Boolean })
], IconsAndInfoBlock.prototype, "isIcon", void 0);
__decorate([
    n({ type: Boolean })
], IconsAndInfoBlock.prototype, "enableSpacing", void 0);
customElements.define('icons-and-info-block', IconsAndInfoBlock);

export { IconsAndInfoBlock };
